var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-21c0d1c3"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { key: 0 };
var _hoisted_2 = { class: "text-center" };
var _hoisted_3 = { class: "text-center mt-4" };
import farmaciAggiuntiveEdit from '@/views/Farmaci/farmaciAggiuntiveEdit.vue';
import farmaciModalConfidenzialita from '@/views/Farmaci/farmaciModalConfidenzialita.vue';
import farmaciModalSposta from '@/views/Farmaci/farmaciModalSposta.vue';
import { saveTerapia, saveAdverseReaction } from '@/../../EshJSLib/services/farmaciServices';
import CollapsibleItem from '@/layout/collapsible/CollapsibleItem.vue';
import { patientStore } from '@/store/patient';
import { storeToRefs } from 'pinia';
import farmaci from '@/../../EshJSLib/models/form/farmaci.json';
import farmaciConclusi from '@/../../EshJSLib/models/form/farmaciConclusi.json';
import farmacivietati from '@/../../EshJSLib/models/form/farmacivietati.json';
import { ref, onMounted, reactive } from 'vue';
import AlertModal from "@/components/AlertModalFeedback.vue";
import axios from 'axios';
import farmaciModalAdverseReactions from '@/views/Farmaci/farmaciModalAdverseReactions.vue';
import { useRouter } from "vue-router";
import { Modal } from "flowbite-vue";
import { hasPermission } from '../../../../EshJSLib/services/securityServices';
//Ref Element with HTML
export default /*#__PURE__*/ _defineComponent({
    __name: 'FarmaciPage',
    props: {
        tipo: Number,
    },
    setup: function (__props) {
        var _this = this;
        var props = __props;
        var modalAddEditFarmaci = ref(null);
        var modalConfidenzialita = ref(null);
        var modalSposta = ref(null);
        var modalAdverseReactions = ref(null);
        var alertModal = ref(null);
        // Constant 
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var showLoading = ref(false);
        var router = useRouter();
        var isShownModalSub = reactive({
            alert: false,
            movePage: false,
            confirm: false,
            alertMove: false,
        });
        function movePage() {
            router.push({ path: 'Paypal' });
        }
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                store.fetchFarmaci();
                store.fetchDiagnosi();
                store.fetchAdverseReaction();
                return [2 /*return*/];
            });
        }); });
        function saveAndRefreshFarmaci(userInput, row) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (userInput) {
                        showLoading.value = true;
                        saveTerapia(row)
                            .then(function (response) {
                            var _a;
                            // Mostra subito l'alertModal con il messaggio dell'API (successo)
                            var message = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Operazione completata con successo";
                            alertModal.value.openModal(message, false); // Mostra il messaggio di successo
                            // Esegui il fetch dei farmaci dopo aver mostrato l'alertModal
                            store.fetchFarmaci().finally(function () {
                                showLoading.value = false;
                            });
                        })
                            .catch(function (error) {
                            var _a, _b;
                            // Gestisci l'errore e mostra subito l'alertModal con il messaggio di errore
                            var errorMessage = ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || "Siamo spiacenti, si è verificato un errore. La preghiamo di riprovare più tardi";
                            alertModal.value.openModal(errorMessage, false); // Mostra il messaggio di errore
                            showLoading.value = false; // Assicurati che il loading finisca anche in caso di errore
                        });
                    }
                    else {
                        store.fetchFarmaci();
                    }
                    return [2 /*return*/];
                });
            });
        }
        function saveAndRefreshAdverse(userInput, row) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (userInput) {
                        showLoading.value = true;
                        saveAdverseReaction(row).then(function (x) {
                            store.fetchAdverseReaction().then(function () {
                                showLoading.value = false;
                            });
                        }).catch(function (error) {
                            showLoading.value = false;
                            alertModal.value.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
                        });
                    }
                    else {
                        store.fetchAdverseReaction();
                    }
                    return [2 /*return*/];
                });
            });
        }
        var adverse = {};
        function action(type, row, index, table) {
            var _a, _b, _c, _d, _e;
            return __awaiter(this, void 0, void 0, function () {
                var userInput, _f;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            userInput = false;
                            _f = type;
                            switch (_f) {
                                case "add": return [3 /*break*/, 1];
                                case "pen": return [3 /*break*/, 6];
                                case "lock": return [3 /*break*/, 11];
                                case "up-down": return [3 /*break*/, 13];
                                case 'trash': return [3 /*break*/, 18];
                                case 'exclamation': return [3 /*break*/, 19];
                                case 'info': return [3 /*break*/, 21];
                            }
                            return [3 /*break*/, 22];
                        case 1: return [4 /*yield*/, hasPermission('aggiungifarmaci')];
                        case 2:
                            if (!_g.sent()) return [3 /*break*/, 4];
                            row = {};
                            row.id_terapie = 0;
                            row.id_paziente = patient.value.id_paziente;
                            row.id_livello_confidenzialita = 6;
                            row.terapie_stato = table;
                            row.tipo_terapia = table;
                            row.status = 'add';
                            return [4 /*yield*/, ((_a = modalAddEditFarmaci.value) === null || _a === void 0 ? void 0 : _a.openModal("Crea Farmaco", row))];
                        case 3:
                            userInput = _g.sent();
                            saveAndRefreshFarmaci(userInput, row);
                            return [3 /*break*/, 5];
                        case 4:
                            isShownModalSub.alert = true;
                            _g.label = 5;
                        case 5: return [3 /*break*/, 22];
                        case 6: return [4 /*yield*/, hasPermission('modificafarmaci')];
                        case 7:
                            if (!_g.sent()) return [3 /*break*/, 9];
                            row.status = 'update';
                            return [4 /*yield*/, ((_b = modalAddEditFarmaci.value) === null || _b === void 0 ? void 0 : _b.openModal("Modifica Farmaco", row))];
                        case 8:
                            userInput = _g.sent();
                            saveAndRefreshFarmaci(userInput, row);
                            return [3 /*break*/, 10];
                        case 9:
                            isShownModalSub.alert = true;
                            _g.label = 10;
                        case 10: return [3 /*break*/, 22];
                        case 11:
                            row.status = 'update';
                            return [4 /*yield*/, ((_c = modalConfidenzialita.value) === null || _c === void 0 ? void 0 : _c.openModal("Modifica Confidenzialita'", row))];
                        case 12:
                            userInput = _g.sent();
                            saveAndRefreshFarmaci(userInput, row);
                            return [3 /*break*/, 22];
                        case 13: return [4 /*yield*/, hasPermission('spostaFarmaci')];
                        case 14:
                            if (!_g.sent()) return [3 /*break*/, 16];
                            row.status = 'update';
                            return [4 /*yield*/, ((_d = modalSposta.value) === null || _d === void 0 ? void 0 : _d.openModal("Sposta", row))];
                        case 15:
                            userInput = _g.sent();
                            saveAndRefreshFarmaci(userInput, row);
                            return [3 /*break*/, 17];
                        case 16:
                            isShownModalSub.alert = true;
                            _g.label = 17;
                        case 17: return [3 /*break*/, 22];
                        case 18:
                            alertModal.value.openModal("Sei sicuro di cancellare il record?", true).then(function (userInput) {
                                row.status = 'delete';
                                saveAndRefreshFarmaci(userInput, row);
                            });
                            return [3 /*break*/, 22];
                        case 19:
                            //adverse.status = 'update'
                            adverse = {};
                            adverse.id_utente = patient.value.id_paziente;
                            adverse.id_terapie = row.id_terapie;
                            return [4 /*yield*/, ((_e = modalAdverseReactions.value) === null || _e === void 0 ? void 0 : _e.openModal("Adverse Reactions", adverse))];
                        case 20:
                            userInput = _g.sent();
                            saveAndRefreshAdverse(userInput, adverse);
                            return [3 /*break*/, 22];
                        case 21:
                            axios.get("/farmacoDetails/" + row.id_farmaco_codifa).then(function (response) {
                                window.open("/farmacoDetails/" + row.id_farmaco_codifa);
                            }, function (error) {
                                alertModal.value.openModal('Nessuna informazione di dettaglio per questo farmaco', false);
                            });
                            return [3 /*break*/, 22];
                        case 22: return [2 /*return*/];
                    }
                });
            });
        }
        return function (_ctx, _cache) {
            var _component_LoadingComponent = _resolveComponent("LoadingComponent");
            return (_unref(patient))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(farmaciAggiuntiveEdit, {
                        ref_key: "modalAddEditFarmaci",
                        ref: modalAddEditFarmaci
                    }, null, 512),
                    _createVNode(farmaciModalConfidenzialita, {
                        ref_key: "modalConfidenzialita",
                        ref: modalConfidenzialita
                    }, null, 512),
                    _createVNode(farmaciModalSposta, {
                        ref_key: "modalSposta",
                        ref: modalSposta
                    }, null, 512),
                    _createVNode(farmaciModalAdverseReactions, {
                        ref_key: "modalAdverseReactions",
                        ref: modalAdverseReactions
                    }, null, 512),
                    _createVNode(CollapsibleItem, {
                        data: _unref(farmaci),
                        onRowActions: _cache[0] || (_cache[0] = function (n, r, i) { return action(n, r, i, 'terapie_inuso'); }),
                        onCreateForm: _cache[1] || (_cache[1] = function ($event) { return (action('add', null, 1, '1')); })
                    }, null, 8, ["data"]),
                    _createVNode(CollapsibleItem, {
                        data: _unref(farmaciConclusi),
                        onRowActions: _cache[2] || (_cache[2] = function (n, r, i) { return action(n, r, i, 'terapie_Conclusi'); }),
                        onCreateForm: _cache[3] || (_cache[3] = function ($event) { return (action('add', null, 2, '2')); })
                    }, null, 8, ["data"]),
                    _createVNode(CollapsibleItem, {
                        data: _unref(farmacivietati),
                        onRowActions: _cache[4] || (_cache[4] = function (n, r, i) { return action(n, r, i, 'terapie_Vietati'); }),
                        onCreateForm: _cache[5] || (_cache[5] = function ($event) { return (action('add', null, 0, '0')); })
                    }, null, 8, ["data"]),
                    _createVNode(AlertModal, {
                        ref_key: "alertModal",
                        ref: alertModal
                    }, null, 512),
                    (showLoading.value)
                        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                        : _createCommentVNode("", true),
                    (isShownModalSub.alert)
                        ? (_openBlock(), _createBlock(_unref(Modal), {
                            key: 1,
                            onClose: _cache[8] || (_cache[8] = function ($event) { return (isShownModalSub.alert = false); })
                        }, {
                            body: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("Questa sezione non è prevista nella tua sottoscrizione")), 1),
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("button", {
                                        onClick: _cache[6] || (_cache[6] = function ($event) { return (isShownModalSub.alert = false); }),
                                        type: "button",
                                        class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                                    }, _toDisplayString(_ctx.$t("Annulla")), 1),
                                    _createElementVNode("button", {
                                        onClick: _cache[7] || (_cache[7] = function ($event) { return (movePage()); }),
                                        type: "button",
                                        class: "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                                    }, _toDisplayString(_ctx.$t("Iscriviti")), 1)
                                ])
                            ]; }),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
